/* eslint-disable */

// How did you end up here ? 🤦

/**
 * BEFORE YOU START USING IT PLEASE ADD ADDITIONAL CLASSES TO EMAIL,
 * PHONE AND ADDRESS FIELDS IN THE RESPECTIVE FORMS.
 * BELOW IS THE NAMING CONVENTION TO USE
 */

/**
 * EMAIL FIELD1 - gcvEmailField
 * TA EMAIL FIELD2(IF ANY) - gcvTaEmailField
 * FOR TA FIELDS (gcvTaEmailField, gcvTaMobileField, gcvTaLandlineField)
 * ADDRESS FIELDS - gcvAddressField1, gcvAddressField2
 * COUNTRY FIELD - gcvCountryField
 * STATE FIELD - gcvStateField
 * OTHER STATE FIELD - gcvStateFieldOther
 * CITY FIELD - GCVCITYFIELD
 * ZIP FIELD - gcvZipField
 * MOBILE FIELD - gcvMobileField
 * LANDLINE FIELD - gcvLandlineField
 */

/**
 * HIDDEN VARIABLES WOULD BE ADDED FROM FEND.JS FILE WHICH WOULD BE
 * USED IN GCV VALIDATION/FORM SUBMISSION
 * HIDDEN VARIABLES THAT GETS ADDED ARE AS BELOW:
 */

/**
 * <input type="hidden" name="mdAddr" id="mdAddr" value="" />
 * <input type="hidden" name="isgcvlog" id="isgcvlog" value="false" />
 * <input type="hidden" name="inputAddr" id="inputAddr" value="" />
 * <input type="hidden" name="emailInvalid" id="emailInvalid" value="" />
 * <input type="hidden" name="mobileInvalid" id="mobileInvalid" value="" />
 * <input type="hidden" name="landLineInvalid" id="landLineInvalid" value="" />
 * <input type="hidden" name="landline2" id="landline2" value="" />
 * <input type="hidden" name="mobile2" id="mobile2" value="" />
 */

/**
 * TO INITIATE GCV VALIDATION THE BELOW ATTRIBUTE NEEDS TO BE ADDED
 * TO THE RESPECTIVE FORM BASED ON THE TYPE OF VALIDATIONS NEEDED
 *
 * data-validate-gcv='{"email":true, "landline": true, "mobile": true, "address": true}'
 *
 */

/**
 * ATTRIBUTE VAL DETAILS
 *
 * "email":true - FOR EMAIL VALIDATION
 * "landline": true - FOR LANDLINE VALIDATION
 * "mobile": true - FOR MOBILE VALIDATION
 * "address": true - FOR ADDRESS VALIDATION
 * "TAemail":true - FOR TA EMAIL VALIDATION
 * "TAlandline": true - FOR TA LANDLINE VALIDATION
 * "TAmobile": true - FOR TA MOBILE VALIDATION
 */

const internals = {};

internals.getCookieValue = function(name) {
  const value = '; ' + document.cookie;
  let parts = value.split('; ' + name + '=');

  if (parts.length == 2) {
    return parts.pop().split(';').shift();
  }
};

internals.scrollToElement = (position) => {
  $('html:not(:animated),body:not(:animated)').animate({
      scrollTop: position
    },
    1100
  );
}

export default class gcvValidator {
  sugestAddress1 = '';
  sugestAddress2 = '';
  sugestAddress3 = '';
  sugestCountry = '';
  sugestState = '';
  sugestCity = '';
  sugestZip = '';
  suggestCounter = 0;
  emailAttempt = 0;
  TAemailAttempt = 0;
  initialMobile = '';
  initialLandline = '';
  mobileHasLandline = false;
  landlineHasMobile = false;
  mobileHasValid = false;
  landlineHasValid = false;
  TAinitialMobile = '';
  TAinitialLandline = '';
  TAmobileHasLandline = false;
  TAlandlineHasMobile = false;
  TAmobileHasValid = false;
  TAlandlineHasValid = false;
  timeout = '';
  submitForm = '';
  skipAddress = false;
  $form;
  gcvFields;
  hasGcvError = false;
  formNumber = 0;
  addressData = {};
  showAddressSuggestions = false;

  constructor($form, gcvFields, random) {
    this.$form = $form;
    this.gcvFields = gcvFields;
    this.formNumber = random;

    this.mobileHasLandline = false;
    this.landlineHasMobile = false;
    this.mobileHasValid = false;
    this.landlineHasValid = false;
    const email = $('.gcvEmailField').val();

    if (internals.getCookieValue('gcvEmailAttempt' + this.formNumber) !== undefined) {
      this.emailAttempt = parseInt(internals.getCookieValue('gcvEmailAttempt' + this.formNumber));
    }

    if (gcvFields.address === undefined) {
      this.skipAddress = true;
    }

    let validateEmail = true;
    let validateTAEmail = true;
    let validateMobile = true;
    let validateLandline = true;
    let validateAddress;

    if (gcvFields.email !== undefined) {
      validateEmail = this.emailValidator(email, false);
    }

    if (!validateEmail) {
      this.hasGcvError = true;
      const position = $('.gcv-error:first').offset().top - 320;

      internals.scrollToElement(position);
      return false;
    }

    if (gcvFields.mobile !== undefined) {
      this.initialMobile = $('.gcvMobileField:visible').val();

      if (this.initialMobile !== '' && this.initialMobile !== undefined) {
        validateMobile = this.validateMobile(this.initialMobile, $('select.gcvCountryField').val(), false);
      }
    }

    if (gcvFields.landline !== undefined) {
      this.initialLandline = $('.gcvLandlineField:visible').val();

      if (this.initialLandline !== '' && this.initialLandline !== undefined) {
        validateLandline = this.validateLandline(this.initialLandline, $('select.gcvCountryField').val(), false);
      }
    }

    /**
     * FOR TA FIELDS (TAEMAIL, TAMOBILE, TALANDLINE) PRESENT IN
     * FORMS LIKE ENGAGEMENT CONCIERGE
     */

    // IN CASE OF TA EMAIL
    if (gcvFields.TAemail !== undefined && $('.travel-agent-information').hasClass('active')) {
      if (internals.getCookieValue('TAgcvEmailAttempt' + this.formNumber) !== undefined) {
        this.TAemailAttempt = parseInt(internals.getCookieValue('TAgcvEmailAttempt' + this.formNumber));
      }
      validateTAEmail = this.emailValidator($('.gcvTaEmailField').val(), true);
    }

    if (!validateTAEmail) {
      this.hasGcvError = true;
      const position = $('.gcv-error:first').offset().top - 320;

      internals.scrollToElement(position);
      return false;
    }

    // IN CASE OF TA MOBILE
    if (gcvFields.TAmobile !== undefined && $('.travel-agent-information').hasClass('active')) {
      this.TAinitialMobile = $('.gcvTaMobileField:visible').val();

      if (this.TAinitialMobile !== '' && this.TAinitialMobile !== undefined) {
        this.validateMobile(this.TAinitialMobile, $('select[name=agencyCountry]').val(), true);
      }
    }

    // IN CASE OF TA LANDLINE
    if (gcvFields.TAlandline !== undefined && $('.travel-agent-information').hasClass('active')) {
      this.TAinitialLandline = $('.gcvTaLandlineField:visible').val();

      if (this.TAinitialLandline !== '' && this.TAinitialLandline !== undefined) {
        this.validateLandline(this.TAinitialLandline, $('select[name=agencyCountry]').val(), true);
      }
    }
    // END TA FIELDS CODE

    if (gcvFields.mobile !== undefined || gcvFields.landline !== undefined) {
      this.phoneSorter();
    }

    if (gcvFields.address !== undefined) {
      validateAddress = this.validateAddress();
    }
  }
  // End of constructor

  apiRequest(url, data, callbacks) {

    $.ajax({
      type: 'POST',
      async: false,
      url: url,
      data: JSON.stringify(data),
      timeout: 20000,
      cache: false,
      contentType: 'application/json',
      success: callbacks.onSuccess,
      error: callbacks.onError
    });
  }

  emailValidator(email, taOrNo) {
    const $this = this;
    let emailValid = true;
    const requestData = { email };
    const callbacks = {};

    callbacks.onSuccess = (freturn) =>{
      const { STATUSNUMBER: statusResponse } = freturn.data.gcvResponse;

      // FOR NON TA EMAIL
      if (!taOrNo) {
        // WHEN EMAIL IS RETURNED AS INVALID
        // NOTE THAT RESPONSE FOR VALID EMAIL IS '200'

        if (statusResponse !== 200 && statusResponse !== 'ERROR') {
          $this.emailAttempt = parseInt($this.emailAttempt) + 1;

          if ($this.emailAttempt < 2) {
            $('.gcvEmailField').addClass('error');
            $('.gcvEmailField').after('<label id="email-error" class="has-error gcv-error" for="email">Email not valid.</label> ');
            // $this.anchorAnimate();
            emailValid = false;
          } else {
            $('#emailInvalid').val(true);
            $('.gcvEmailField').removeClass('error');
            $('.gcvEmailField').parent().find('.gcv-error').remove();
            // $this.emailToNext();
            emailValid = true;
          }
        }
        // WHEN THERE IS AN ERROR IN THE SERVICE CALL OR TIMEOUT
        // NOTE THAT RESPONSE FOR ERROR OR TIMEOUT IS 'ERROR'
        else if (statusResponse == 'ERROR') {
          $('#emailInvalid').val('ERROR');
          $this.emailAttempt = 2;
          $('.gcvEmailField').removeClass('error');
          $('.gcvEmailField').parent().find('.gcv-error').remove();
          emailValid = true;
        } else {
          $('#emailInvalid').val(false);
          $('.gcvEmailField').removeClass('error');
          $('.gcvEmailField').parent().find('.gcv-error').remove();
          emailValid = true;
        }
      } else {
        // FOR  TA EMAIL
        if (statusResponse !== 200 && statusResponse !== 'ERROR') {
          $this.TAemailAttempt = parseInt($this.TAemailAttempt) + 1;

          if ($this.TAemailAttempt < 2) {
            $('.gcvTaEmailField').addClass('error');
            $('.gcvTaEmailField').after('<label id="email-error" class="has-error gcv-error" for="email">Email not valid.</label> ');
            // $this.anchorAnimate();
            emailValid = false;
          } else {
            $('#taemailInvalid').val(true);
            $('.gcvTaEmailField').removeClass('error');
            $('.gcvTaEmailField').parent().find('.gcv-error').remove();
            // $this.emailToNext();
            emailValid = true;
          }
        }
        // WHEN THERE IS AN ERROR IN THE SERVICE CALL OR TIMEOUT
        // NOTE THAT RESPONSE FOR ERROR OR TIMEOUT IS 'ERROR'
        else if (statusResponse == 'ERROR') {
          $('#taemailInvalid').val('ERROR');
          $this.TAemailAttempt = 2;
          $('.gcvTaEmailField').removeClass('error');
          $('.gcvTaEmailField').parent().find('.gcv-error').remove();
          emailValid = true;
        } else {
          $('#taemailInvalid').val(false);
          $('.gcvTaEmailField').removeClass('error');
          $('.gcvTaEmailField').parent().find('.gcv-error').remove();
          emailValid = true;
        }
      }
    };

    callbacks.onError = (jqXHR, textStatus, errorThrown) => {
      $('#emailInvalid').val('ERROR');
      $this.emailAttempt = 2;
      $('.gcvEmailField').removeClass('error');
      $('.gcvEmailField').parent().find('.gcv-error').remove();
      emailValid = true;
    };

    this.apiRequest('/gcv/email/', requestData, callbacks);

    let date = new Date();
    date.setTime(date.getTime() + 60 * 60 * 1000);

    if (!taOrNo) {
      document.cookie =  `gcvEmailAttempt${this.formNumber} = ${$this.emailAttempt}; domain=.beaches.com;path=/; expires= ${date}`;
    } else {
      document.cookie = `TAgcvEmailAttempt${this.formNumber} = ${$this.TAemailAttempt}; domain=.beaches.com;path=/; expires=${date}`;
    }

    return emailValid;
  }

  validateMobile(number, country, taOrNo) {
    const $this = this;
    const requestData = {
      phoneNumber: number,
      CountryCode: country,
      inputType: 'mobile'
    };
    const callbacks = {};

    callbacks.onSuccess = (freturn) => {
      /**
       * NOTE THAT RESPONSE FOR VALID LANDLINE IS '201 LandLine'
       * NOTE THAT RESPONSE FOR VALID MOBILE IS '201 Mobile'
       * FOR THE ERROR OR TIMEOUT IN THE SERVICE THE REPONSE IS 'ERROR'
       */
      const { STATUSNUMBER, PHONENUMBERTYPE } = freturn.data.gcvResponse;
      const statusResponse = `${STATUSNUMBER} ${PHONENUMBERTYPE}`;

      if (!taOrNo) {
        // FOR NON TA MOBILE
        if ($.trim(statusResponse) == '201 LandLine') {
          $this.mobileHasLandline = true;
        } else if ($.trim(statusResponse) == '201 Mobile') {
          $('.gcvMobileField').removeClass('error');
          $this.mobileHasValid = true;
          $this.mobileHasLandline = false;
        } else if ($.trim(statusResponse) == 'ERROR') {
          $('.gcvMobileField').removeClass('error');
          $('#mobileInvalid').val('ERROR');
          $this.mobileHasValid = true;
          $this.mobileHasLandline = false;
        } else {
          $this.mobileHasLandline = false;
          $this.mobileHasValid = false;
          $('#mobileInvalid').val(false);
        }
      } else {
        // FOR TA MOBILE
        if ($.trim(statusResponse) == '201 LandLine') {
          $this.TAmobileHasLandline = true;
        } else if ($.trim(statusResponse) == '201 Mobile') {
          $('.gcvTaMobileField').removeClass('error');
          $this.TAmobileHasValid = true;
          $this.TAmobileHasLandline = false;
        } else if ($.trim(statusResponse) == 'ERROR') {
          $('.gcvTaMobileField').removeClass('error');
          $('#tamobileInvalid').val('ERROR');
          $this.TAmobileHasValid = true;
          $this.TAmobileHasLandline = false;
        } else {
          $this.TAmobileHasLandline = false;
          $this.TAmobileHasValid = false;
          $('#tamobileInvalid').val(false);
        }
      }
    };

    callbacks.onError = (jqXHR, textStatus, errorThrown) => {
      if (textStatus === 'timeout') {
        $('.gcvMobileField').removeClass('error');
        $('#mobileInvalid').val('ERROR');
        $this.mobileHasValid = true;
        $this.mobileHasLandline = false;
      } else {
        console.error(errorThrown);
      }
    };

    this.apiRequest('/gcv/phone/', requestData, callbacks);

    return true;
  }

  // LANDLINE VALIDATION METHOD
  validateLandline(number, country, taOrNo) {
    if (number === '') {
      return false;
    }
    const $this = this;
    const requestData = {
      phoneNumber: number,
      CountryCode: country,
      inputType: 'landline'
    };
    const callbacks = {};

    callbacks.onSuccess = (freturn) => {
      /**
       * NOTE THAT RESPONSE FOR VALID LANDLINE IS '201 LandLine'
       * NOTE THAT RESPONSE FOR VALID MOBILE IS '201 Mobile'
       * FOR THE ERROR OR TIMEOUT IN THE SERVICE THE REPONSE IS 'ERROR'
       */
      const { STATUSNUMBER, PHONENUMBERTYPE } = freturn.data.gcvResponse;
      const statusResponse = `${STATUSNUMBER} ${PHONENUMBERTYPE}`;

      if (!taOrNo) {
        // FOR NON TA LANDLINE
        if ($.trim(statusResponse) == '201 LandLine') {
          $this.landlineHasValid = true;
          $('.gcvLandlineField').removeClass('error');
          $this.landlineHasMobile = false;
        } else if ($.trim(statusResponse) == '201 Mobile') {
          $this.landlineHasMobile = true;
        } else if ($.trim(statusResponse) == 'ERROR') {
          $this.landlineHasValid = true;
          $('#landLineInvalid').val('ERROR');
          $('.gcvLandlineField').removeClass('error');
          $this.landlineHasMobile = false;
        } else {
          $this.landlineHasValid = false;
          $this.landlineHasMobile = false;
          $('#landLineInvalid').val(false);
        }
        $('.gcvLandlineField').removeClass('error');
      } else {
        if ($.trim(statusResponse) == '201 LandLine') {
          $this.TAlandlineHasValid = true;
          $('.gcvTaLandlineField').removeClass('error');
          $this.TAlandlineHasMobile = false;
        } else if ($.trim(statusResponse) == '201 Mobile') {
          $this.TAlandlineHasMobile = true;
        } else if ($.trim(statusResponse) == 'ERROR') {
          $this.TAlandlineHasValid = true;
          $('#talandLineInvalid').val('ERROR');
          $('.gcvTaLandlineField').removeClass('error');
          $this.TAlandlineHasMobile = false;
        } else {
          $this.TAlandlineHasValid = false;
          $this.TAlandlineHasMobile = false;
          $('#talandLineInvalid').val(false);
        }
        $('.gcvTaLandlineField').removeClass('error');
      }
    };

    callbacks.onError = (jqXHR, textStatus, errorThrown) => {
      // FOR TA LANDLINE
      if (textStatus === 'timeout') {
        $this.landlineHasValid = true;
        $('#landLineInvalid').val('ERROR');
        $('.gcvLandlineField').removeClass('error');
        $this.landlineHasMobile = false;
      } else {
        console.error(errorThrown);
      }
    };

    this.apiRequest('/gcv/phone/', requestData, callbacks);

    return true;
  }

  phoneSorter() {
    if (this.landlineHasMobile && this.mobileHasLandline) {
      this.$form.find('.gcvMobileField').val(this.initialLandline);
      this.$form.find('.gcvLandlineField').val(this.initialMobile);
    } else if (this.landlineHasMobile && !this.mobileHasValid) {
      this.$form.find('.gcvMobileField').val(this.initialLandline);
      this.$form.find('.gcvLandlineField').val('');
    } else if (this.landlineHasMobile && this.mobileHasValid) {
      this.$form.find('.gcvLandlineField').val('');
      this.$form.find('#mobile2').val(this.initialLandline);
    } else if (this.mobileHasLandline && !this.landlineHasValid) {
      this.$form.find('.gcvLandlineField').val(this.initialMobile);
      this.$form.find('.gcvMobileField').val('');
    } else if (this.mobileHasLandline && this.landlineHasValid) {
      this.$form.find('.gcvMobileField').val('');
      this.$form.find('#landline2').val(this.initialMobile);
    } else if (!this.landlineHasValid && this.mobileHasValid) {
      this.$form.find('.gcvLandlineField').val('');
    } else if (this.landlineHasValid && !this.mobileHasValid) {
      this.$form.find('.gcvMobileField').val('');
    } else if (!this.landlineHasValid && !this.mobileHasValid) {
      this.$form.find('.gcvLandlineField').val('');
      this.$form.find('.gcvMobileField').val('');
    } else {}

    // FOR  TA NUMBERS
    if (this.TAlandlineHasMobile && this.TAmobileHasLandline) {
      $('.gcvTaMobileField').val(this.TAinitialLandline);
      $('.gcvTaLandlineField').val(this.TAinitialMobile);
    } else if (this.TAlandlineHasMobile && !this.TAmobileHasValid) {
      $('.gcvTaMobileField').val(this.TAinitialLandline);
      $('.gcvTaLandlineField').val('');
    } else if (this.TAlandlineHasMobile && this.TAmobileHasValid) {
      $('.gcvTaLandlineField').val('');
      $('#tamobile2').val(this.TAinitialLandline);
    } else if (this.TAmobileHasLandline && !this.TAlandlineHasValid) {
      $('.gcvTaLandlineField').val(this.TAinitialMobile);
      $('.gcvTaMobileField').val('');
    } else if (this.TAmobileHasLandline && this.TAlandlineHasValid) {
      $('.gcvTaMobileField').val('');
      $('#talandline2').val(this.TAinitialMobile);
    } else if (!this.TAlandlineHasValid && this.TAmobileHasValid) {
      $('.gcvTaLandlineField').val('');
    } else if (this.TAlandlineHasValid && !this.TAmobileHasValid) {
      $('.gcvTaMobileField').val('');
    } else if (!this.TAlandlineHasValid && !this.TAmobileHasValid) {
      $('.gcvTaLandlineField').val('');
      $('.gcvTaMobileField').val('');
    }
  }

  validateAddress() {
    let $address;
    let $address2;
    let $country;
    let $state;
    let $otherState;
    let $city;
    let $zip;
    let addressValid = false;
    const $this = this;

    if ($('.gcvAddressField1').is(':visible')) {
      $address = $.trim($('.gcvAddressField1').val());
    }
    if ($('.gcvAddressField2').is(':visible')) {
      $address2 = $.trim($('.gcvAddressField2').val());
    }

    $country = $.trim($('select.gcvCountryField').val());
    $state = $.trim($('select.gcvStateField').val());

    if ($('.gcvStateFieldOther').is(':visible')) {
      $otherState = $.trim($('.gcvStateFieldOther').val());
    }
    if ($('.gcvCityField').is(':visible')) {
      $city = $.trim($('.gcvCityField').val());
    }
    if ($('.gcvZipField').is(':visible')) {
      $zip = $.trim($('.gcvZipField').val()).toUpperCase();
    }

    const inputCountry = $country;
    let inputState = '';

    if ($country == 'US' || $country == 'GB' || $country == 'CA') {
      inputState = $state;
    } else {
      inputState = encodeURIComponent($otherState);
    }

    const requestData = {
      street1: $address || '',
      street2: $address2 || '',
      street3: '',
      country: inputCountry || '',
      state: inputState || '',
      city: $city || '',
      suite: '',
      zipcode: $zip || ''
    };
    const callbacks = {};

    callbacks.onSuccess = (freturn) => {
      const { gcvResponse } = freturn.data;
      const {
        RESPONSE_RESULTS: {
          SUCCESS: success,
          SHOWSUGGESTEDADDR: shouldShowSuggestedAddress
        },
        INPUT_ARGUMENTS: {
          FORMATTEDADDR: userInputAddress
        },
        FORMATTEDADDRESS: {
          FORMATTEDADDRESS: formattedAddress
        }
      } = gcvResponse;

      $this.addressData = gcvResponse;

      if (success.toUpperCase() === 'FALSE') {
        $('#inputAddr').val(decodeURIComponent(userInputAddress));
        $('#isgcvlog').val(true);

        $this.showAddressSuggestions = false;
      } else if (success.toUpperCase() == 'ERROR') {
        $('#inputAddr').val(decodeURIComponent(userInputAddress));
        $('#isgcvlog').val('ERROR');
        $this.showAddressSuggestions = false;
      } else if (success.toUpperCase() === 'TRUE' && shouldShowSuggestedAddress.toUpperCase() === 'TRUE') {
        $('#inputAddr').val(userInputAddress);
        $('#mdAddr').val(formattedAddress);

        $this.showAddressSuggestions = true;
      } else if (success && !shouldShowSuggestedAddress) {
        $this.showAddressSuggestions = false;
      }
    };

    callbacks.onError = (jqXHR, textStatus, errorThrown) => {
      if (textStatus === 'timeout') {
        $('#inputAddr').val(decodeURIComponent(userInputAddress));
        $('#isgcvlog').val('ERROR');
        $this.showAddressSuggestions = false;
      } else {
        console.log(errorThrown);
      }
    };

    this.apiRequest('/gcv/address/', requestData, callbacks);
  }
}
